import { HStack, Icon, Text } from '@genial/components';
import { Color } from '@genial/design-tokens';
import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';

interface DocumentsListingFilterButtonProps {
  appliedFiltersCount: number;
  onPress: () => void;
}

const LISTING_ACTION_HEIGHT = 36;

const styles = StyleSheet.create({
  pressable: {
    alignSelf: 'center',
  },
  container: {
    borderWidth: 1,
    borderColor: Color['brand.primary.principal'],
    borderStyle: 'solid',
    borderRadius: 9999,
    backgroundColor: 'transparent',
    height: LISTING_ACTION_HEIGHT,
    maxHeight: LISTING_ACTION_HEIGHT,
    paddingHorizontal: 16,
    justifyContent: 'center',
    alignItems: 'center',
    elevation: 0,
    shadowOpacity: 0,
    shadowRadius: 0,
    shadowOffset: { width: 0, height: 0 },
    boxShadow: 'none',
  },
});

export const DocumentsListingFilterButton: React.FC<DocumentsListingFilterButtonProps> = ({
  appliedFiltersCount,
  onPress,
}) => (
  <Pressable testID="documents-listing-filter-button" onPress={onPress} style={styles.pressable}>
    <View style={styles.container}>
      <HStack space="12px" alignItems="center">
        {appliedFiltersCount === 0 ? (
          <Icon
            name="Funnel"
            size="xxxs"
            testId="documents-listing-filter-icon"
            color="brand.primary.principal"
          />
        ) : null}
        <Text variant="bold" fontSize="md" color="brand.primary.principal">
          Filtros{appliedFiltersCount > 0 ? ` (${appliedFiltersCount})` : ''}
        </Text>
      </HStack>
    </View>
  </Pressable>
);
